import React from 'react'

// HealthyCoach lockup: a blue rounded-square mark plus the wordmark.
const Logo = ({ inverse = false, size = 'md' }) => {
  const mark = size === 'lg' ? 'h-9 w-9 rounded-[9px] text-[13px]' : 'h-7 w-7 rounded-[7px] text-[11px]'
  const word = size === 'lg' ? 'text-xl' : 'text-base'
  return (
    <span className="flex items-center gap-2.5">
      <span className={`flex items-center justify-center bg-blue-600 font-semibold text-white ${mark}`}>HC</span>
      <span className={`font-semibold tracking-tight ${word} ${inverse ? 'text-white' : 'text-slate-900'}`}>
        HealthyCoach
      </span>
    </span>
  )
}

export default Logo
